/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StreamedAwardAgreementImportService {

    /**
     * @param sessionId
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiStreamedAwardAgreementImportPerformImport(
        sessionId: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/streamed-award-agreement-import/perform-import/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sessionId
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiStreamedAwardAgreementImportTest(
        sessionId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/streamed-award-agreement-import/test/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
